import type { Baby, Call, Dose, Flag, Mother } from '../types';
import { isReal, loadClinic } from './store';
import { respond } from './respond';
import { mothers } from './mockData';
import { scope } from './scope';

const viaStore = async <T>(facilityId: string, pick: (c: Awaited<ReturnType<typeof loadClinic>>) => T): Promise<T> => {
  const c = await loadClinic(facilityId);
  return c.real ? pick(c) : respond(pick(c));
};

export const getMothers = (facilityId: string): Promise<Mother[]> => viaStore(facilityId, (c) => c.mothers);
export const getBabies = (facilityId: string): Promise<Baby[]> => viaStore(facilityId, (c) => c.babies);
export const getDoses = (facilityId: string): Promise<Dose[]> => viaStore(facilityId, (c) => c.doses);
export const getCalls = (facilityId: string): Promise<Call[]> => viaStore(facilityId, (c) => c.calls);
export const getFlags = (facilityId: string): Promise<Flag[]> => viaStore(facilityId, (c) => c.flags);

export async function getMother(id: string): Promise<Mother> {
  const fid = isReal() ? scope().facilityId : mothers.find((x) => x.id === id)?.facilityId ?? '';
  const m = (await loadClinic(fid)).mothers.find((x) => x.id === id);
  if (!m) throw new Error(`Mother ${id} not found`);
  return isReal() ? m : respond(m);
}
